module.exports = __webpack_public_path__ + "static/p10_pastoTop-6df628db400c04b6f175e9b2cf5c96d1.png";